import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
export const CustomRadarChart = ({ data, title }) => {
  const formattedData = data.map(item => ({
    ...item,
    name: item.name === "Call Abandonment" ? "Call Abandonment Rate" : item.name,
    value: Number.parseFloat(item.value || 0).toFixed(2),
  }));

  const maxValue = data?.length 
    ? Math.max(...formattedData.map(item => Number(item.value)), 100)
    : 100;

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <ResponsiveContainer width="100%" height={320}>
        <RadarChart cx="50%" cy="50%" outerRadius="65%" data={formattedData}>
          <PolarGrid stroke="#e0e0e0" />
          <PolarAngleAxis 
            dataKey="name" 
            tick={{ fill: '#333', fontSize: 12 }}
            tickLine={{ stroke: '#ccc' }}
            style={{
              fontSize: '12px'
            }}
          />
          <PolarRadiusAxis 
            angle={60} 
            domain={[0, maxValue]}
            tick={{ fill: '#666', fontSize: 10 }}
            axisLine={{ stroke: '#ccc' }}
          />
          <Radar 
            name="Metrics"
            dataKey="value" 
            stroke="#02042D" 
            fill="#02042D" 
            fillOpacity={0.6}
          />
          <Tooltip 
            contentStyle={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}
            formatter={(value) => [`${value}`, 'Value']}
          />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
    </Box>
  );
};

CustomRadarChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  title: PropTypes.string,
};

export default CustomRadarChart;